module.exports = __webpack_public_path__ + "assets/search.c6a0effb.svg";